/** Types of notification messages
 *  Used in NotificationMessage and ToastItem components.
 */
export const NotificationTypes = {
  error: { alert: 'alert-danger', icon: 'pficon-error-circle-o' },
  info: { alert: 'alert-info', icon: 'pficon-info' },
  success: { alert: 'alert-success', icon: 'pficon-ok' },
  warning: { alert: 'alert-warning', icon: 'pficon-warning-triangle-o' },
  unknown: { alert: 'alert-info', icon: 'fa fa-regular fa-question-circle' },
};
